import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BuyInsurancePage } from './buy-insurance';

@NgModule({
  declarations: [
    BuyInsurancePage,
  ],
  imports: [
    IonicPageModule.forChild(BuyInsurancePage),
  ],
})
export class BuyInsurancePageModule {}



// WEBPACK FOOTER //
// ./src/pages/buy-insurance/buy-insurance.module.ts